// extracted by mini-css-extract-plugin
export default {"section":"CoachesWelcomeSection_section__4Z59D","section_children":"CoachesWelcomeSection_section_children__BvJeJ"};